const LOAD_DETAIL_INSTRUCTOR           = 'LOAD_DETAIL_INSTRUCTOR'
const LOAD_DETAIL_INSTRUCTOR_SUCCESS   = 'LOAD_DETAIL_INSTRUCTOR_SUCCESS'
const LOAD_DETAIL_INSTRUCTOR_FAILED    = 'LOAD_DETAIL_INSTRUCTOR_FAILED'
const UNMOUNT_DETAIL_INSTRUCTOR        = 'UNMOUNT_DETAIL_INSTRUCTOR'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const InstructorDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_INSTRUCTOR:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_INSTRUCTOR_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_INSTRUCTOR_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_INSTRUCTOR:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default InstructorDetailReducer;